// @ts-strict-ignore
import { Component, ReactNode } from 'react';
import { connect } from 'react-redux';

import { ErrorPage } from 'modules/main/pages/Error';
import { NotFoundPage } from 'modules/main/pages/NotFound';
import { log } from 'utils/logging';
import { trackError } from 'utils/trackError';

type OwnProps = {
  children: ReactNode;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderErrorPage?: (arg0: Record<string, any>) => ReactNode;
  renderNotFoundPage?: () => ReactNode;
};
type Props = OwnProps & {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: Record<string, any> | null | undefined;
};
type State = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: Record<string, any> | null | undefined;
};

class ErrorBoundary extends Component<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    error: null, // error from uncaught exception
  };

  componentDidCatch(
    error: Error,
    info: {
      componentStack: string;
    }
  ) {
    this.setState({
      error,
    });

    log.error(`stacktrace:\n${info.componentStack}`);
    trackError(error);
  }

  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    const error = this.state.error || this.props.error;

    if (error) {
      if (error.statusCode === 404) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        if (this.props.renderNotFoundPage) {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          return this.props.renderNotFoundPage();
        }

        return <NotFoundPage />;
      }

      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      if (this.props.renderErrorPage) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        return this.props.renderErrorPage(error);
      }

      return <ErrorPage error={error} />;
    }

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    return this.props.children;
  }
}

const mapStateToProps = ({ error }) => ({
  error,
});

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(ErrorBoundary);
